module.exports = __webpack_public_path__ + "static/media/logos@3x.0cf2f170.png";